import {
  FOC_TOUR_LABEL_PLN_RESOURCE,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_PLN_RESOURCE_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlnTourPopoverHtml,
  requirement,
  type FocPlnTourStepDef,
} from './focPlnTourTypes';

export const FOC_PLN_RESOURCE_TOUR_PARAM = 'focPlnResourceTour';
export const FOC_PLN_RESOURCE_TOUR_HREF = HREF;
export { focPlnTourPopoverHtml };

export const FOC_PLN_RESOURCE_TOUR_STEPS: FocPlnTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'pln-resource-workspace',
    title: FOC_TOUR_LABEL_PLN_RESOURCE,
    description:
      'The Resource Unit workspace covers incident roster status, resource status, check-in/out, accountability, assignments, availability, resource-order coordination, draft/current operational-period organization, and demobilization information.',
  },
  requirement({
    id: 'pln003',
    requirementId: 'FOC-PLN-003',
    name: 'Resource Unit Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'pln-resource-workspace',
    description:
      'PRATUS provides a Resource Unit workspace for incident roster status, resource status, check-in/check-out, personnel accountability, resource assignments, resource availability, resource-order coordination, draft/current operational-period organization, and demobilization information.',
    bullets: [
      'FOC-PLN-003a — Resource Status Board: ordered, en route, available, assigned, temporarily unavailable, out-of-service, demobilizing, released, and other approved states; assignment; location; ETA; check-in; home unit/owner; operational-period relevance.',
      'FOC-PLN-003b — Current and Next Organization/Resource Planning: maintain current-period assignments while building next-period plans; drafts do not overwrite current assignments until approved/effective.',
      'FOC-PLN-003c — Standard Resource Kinds: controlled Coast Guard vocabulary aligned to ICS 219/T-card categories (Crew/Team, Engine, Helicopter, Personnel, Fixed-Wing, Equipment, Vessels); governance can add mission-specific kinds without uncontrolled duplicates.',
      'FOC-PLN-003d — Accountable Resource Tracking / ICS 261: accountable-resource tracking and source-faithful ICS 261 output; reuses authoritative resource records.',
      'FOC-PLN-003e — Resource ETA: incoming resources include estimated arrival when known; visible in request, Resources Unit, Logistics, Operations, and applicable COP/briefing views with source and last-updated information.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLN_RESOURCE),
  },
];
